import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { feedbackStyles } from '../../Styles/feedbackStyles';
import { inject, observer } from 'mobx-react';
import Typography from '@material-ui/core/Typography';
import { Divider } from 'material-ui';

@inject('queryStore')
@observer
class FeedbackDetails extends Component {

    render() {
        const { classes } = this.props;
        const { item } = this.props
        return (
            <div style={{ paddingTop: '5vh' }}>
                <div style={{ fontSize: '12px' }} className={classes.feedbackText} >
                    On {new Date(item.createdAt).toDateString()}, you have enquired about
                        </div>
                <Typography className={classes.feedbackInfo} variant="subtitle1" >
                {item.allStepsData.textToShow}
                </Typography>
                <div className={classes.feedbackText} >
                Policy: {item.stepsData.step_1.stepData_policyId}
                </div>

            </div>
        )
    }
}
FeedbackDetails.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(feedbackStyles)(FeedbackDetails);
